<template>
  <div class="loading_skeleton">

    <el-skeleton animated>
      <template #template>
        <div style="display: flex; justify-content: space-between; margin-bottom: 20px">
          <div>
            <el-skeleton-item style="width: 70px; height: 32px; margin-right: 10px" variant="button"/>
            <el-skeleton-item style="width: 70px; height: 32px" variant="button"/>
          </div>
          <el-skeleton-item style="width: 270px; height: 32px" variant="text"/>
        </div>
      </template>
    </el-skeleton>
    <el-skeleton :rows="8" animated/>
  </div>
</template>

<script>
export default {
  name: "LoadingSkeleton"
}
</script>

<style scoped lang="scss">
.loading_skeleton {
  height: 100%;
  background-color: #ffffff;
  padding: 26px 18px 0 18px;
}
</style>
